import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SetupInfoComponent } from './setup-info.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [CommonModule, HttpClientModule, SetupInfoComponent],
  exports: [SetupInfoComponent],
})
export class SetupInfoModule {}